import { Code } from "@connectrpc/connect";
import type { DefaultMaterialsSettings as RpcDefaultMaterialsSettings } from "../../../generated/cadendar-rpc/cadendar/defaultmaterials/v1/default_materials_pb";
import {
  defaultMaterialsByActKindSaveInputSchema,
  type DefaultMaterialsByActKindSettings,
} from "cadendar-shared";
import { getCadendarRpcErrorCode } from "../../main/components/cadendarRpc";

export function getDefaultMaterialsErrorMessage(error: unknown) {
  if (
    error instanceof Error &&
    error.message === "Praticien sélectionné introuvable."
  ) {
    return error.message;
  }

  switch (getCadendarRpcErrorCode(error)) {
    case Code.PermissionDenied:
      return "Vous n'êtes pas autorisé à modifier ces réglages.";
    case Code.InvalidArgument:
      return "Les réglages des matériaux sont invalides.";
    case Code.Unavailable:
      return "Le service des réglages est temporairement indisponible.";
    default:
      return "Impossible de charger ou d'enregistrer les réglages pour le moment.";
  }
}

export function settingsFromRpc(
  settings: RpcDefaultMaterialsSettings | undefined,
) {
  if (!settings) {
    throw new Error("La réponse ne contient pas les réglages des matériaux.");
  }

  return defaultMaterialsByActKindSaveInputSchema.parse({
    defaultByFamily: Object.fromEntries(
      settings.defaultByFamily.map((material) => {
        if (material.disabled === (material.materialCode !== undefined)) {
          throw new Error("La réponse contient un matériau ambigu.");
        }
        return [
          material.family,
          material.disabled ? null : material.materialCode,
        ];
      }),
    ),
    networkOverrides: Object.fromEntries(
      settings.networkOverrides.map((network) => [
        network.network,
        Object.fromEntries(
          network.materials.map((material) => {
            if (material.disabled === (material.materialCode !== undefined)) {
              throw new Error("La réponse contient un matériau ambigu.");
            }
            return [
              material.family,
              material.disabled ? null : material.materialCode,
            ];
          }),
        ),
      ]),
    ),
  });
}

export function settingsToRpc(settings: DefaultMaterialsByActKindSettings) {
  return {
    defaultByFamily: Object.entries(settings.defaultByFamily).map(
      ([family, materialCode]) => ({
        family,
        materialCode: materialCode ?? undefined,
        disabled: materialCode === null,
      }),
    ),
    networkOverrides: Object.entries(settings.networkOverrides).map(
      ([network, materials]) => ({
        network,
        materials: Object.entries(materials).map(([family, materialCode]) => ({
          family,
          materialCode: materialCode ?? undefined,
          disabled: materialCode === null,
        })),
      }),
    ),
  };
}
